/* eslint-disable no-console */
import { db } from "@/firebase";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  orderBy
} from "firebase/firestore";
import _ from "lodash";

const state = {
  companies: [],
  loadingCompanies: false
};

const actions = {
  async loadCompanies({ commit, getters }) {
    commit("setLoadingCompanies", true);

    try {
      const programRef = doc(db(), "programs", getters.programId);
      const companiesRef = collection(programRef, "companies");
      const companiesQuery = query(companiesRef, orderBy("titleUppercase"));
      const querySnapshot = await getDocs(companiesQuery);

      const companies = [];
      querySnapshot.forEach(function(docSnapshot) {
        const data = docSnapshot.data();
        companies.push({
          id: docSnapshot.id,
          importBatchId: data.importBatchId,
          title: data.title,
          titleUppercase: data.titleUppercase,
          accountKey: data.accountKey || "",
          status: data.status,
          points: data.points,
          tags: data.tags || [],
          members: data.members || [],
          created: data.created?.toDate() || new Date(),
          updated: data.updated?.toDate() || new Date()
        });
      });

      commit("setCompanies", companies);
    } catch (error) {
      console.error("Error loading companies:", error);
      commit("setCompanies", []);
    } finally {
      commit("setLoadingCompanies", false);
    }
  },

  async getCompanyById({ getters }, companyId) {
    try {
      const programRef = doc(db(), "programs", getters.programId);
      const companiesRef = collection(programRef, "companies");
      const companyRef = doc(companiesRef, companyId);
      const companyDoc = await getDoc(companyRef);

      if (companyDoc.exists()) {
        const data = companyDoc.data();
        return {
          id: companyDoc.id,
          ...data,
          created: data.created?.toDate() || new Date(),
          updated: data.updated?.toDate() || new Date()
        };
      } else {
        console.warn(`Company with ID ${companyId} not found`);
        return null;
      }
    } catch (error) {
      console.error("Error getting company by ID:", error);
      return null;
    }
  }
};

const mutations = {
  setCompanies(state, payload) {
    state.companies = payload;
  },

  setLoadingCompanies(state, payload) {
    state.loadingCompanies = payload;
  }
};

const getters = {
  companies(state) {
    return state.companies;
  },

  loadingCompanies(state) {
    return state.loadingCompanies;
  },

  getCompanyByAccountKey: state => accountKey => {
    return state.companies.find(company => company.accountKey === accountKey);
  },

  getCompanyByTitle: state => title => {
    return state.companies.find(
      company => company.title.toLowerCase() === title.toLowerCase()
    );
  },

  companiesByStatus: state => status => {
    return state.companies.filter(company => company.status === status);
  },

  companiesWithTag: state => tag => {
    return state.companies.filter(
      company => company.tags && company.tags.includes(tag)
    );
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
